module.exports = __webpack_public_path__ + "images/gifter-51ae7b0fc743972540f4321bf9adcd04.png";